import { RadioGroup } from '@distribusion/owl-frontend-ui'
import { Field, getIn, useFormikContext } from 'formik'
import { FieldProps } from 'formik/dist/Field'
import React, { ReactElement, useEffect, useMemo } from 'react'

import { useTranslation } from '@lib/i18n'

type Gender = 'F' | 'M'
export type GenderWithNoInfo = Gender | 'OTHER'

const GENDERS: Gender[] = ['F', 'M']

interface GenderProps {
  name: string
  includeNoInfo?: boolean
  hideLabel?: boolean
}

const Gender = ({ name, includeNoInfo, hideLabel }: GenderProps): ReactElement => {
  const { t } = useTranslation()
  const genderOptions = useMemo(() => {
    const options: Array<{ value: GenderWithNoInfo; label: string }> = GENDERS.map(value => ({
      value,
      label: t(`checkout.passengerDetails.gender.${value}`),
    }))
    if (includeNoInfo) {
      options.push({
        value: 'OTHER',
        label: t('checkout.passengerDetails.gender.noInfo'),
      })
    }

    return options
  }, [t, includeNoInfo])

  const { setFieldValue, values } = useFormikContext()
  useEffect(() => {
    if (getIn(values, name) == null) {
      setFieldValue(name, GENDERS[0])
    }
  }, [name, setFieldValue, values])

  return (
    <Field name={name}>
      {({ field, form }: FieldProps<GenderWithNoInfo>) => (
        <div className="gender-control">
          <RadioGroup
            label={!hideLabel ? t('checkout.passengerDetails.gender.label') : ''}
            value={field.value}
            options={genderOptions}
            onChange={value => {
              form.setFieldValue(name, value)
            }}
            direction="row"
          />
        </div>
      )}
    </Field>
  )
}

export default Gender
